import paymentsApi from '@modules/payments/api';
import { useQuery } from '@tanstack/react-query';

const useGetProducts = () => {
  const { isLoading, data, error } = useQuery({
    queryKey: ['paymentsProducts'],
    queryFn: () => paymentsApi.getProducts(),
    staleTime: 60 * 10, // 10 minutes
    retry: 2,
  });

  return {
    data,
    isLoading,
    error,
  };
};

export { useGetProducts };
